import React from "react";
import Layout from "../../components/Layout/Layout";
import FirstSlider from "../../components/pages/Home/MainSlider/FirstSlider";
import CatalogLink from "../../components/pages/Home/CatalogLink/CatalogLink";
import NewGoods from "../../components/pages/Home/NewGoods/NewGoods";
import GeneralSlider from "../../components/general/GeneralSlider/GeneralSlider";
import Ideas from "../../components/pages/Home/Ideas/Ideas";
import Feedback from "../../components/general/Feedback/Feedback";
import Company from "../../components/pages/Home/Company/Company";

import styles from "./HomePage.module.scss";

const goodsArr = [
  { id: 0, img: "/img/main/temp/1.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 1, img: "/img/main/temp/2.jpg", title: "Атлас ALASKA", colors: "20 цветов", price: 689 },
  { id: 2, img: "/img/main/temp/3.jpg", title: "Плательная ткань PUDRA", colors: "9 цветов", price: 792 },
  { id: 3, img: "/img/main/temp/4.jpg", title: "Органза CORTEX", colors: "10 цветов", price: 497 },
  { id: 4, img: "/img/main/temp/5.jpg", title: "Бархат BARSELONA", colors: "23 цвета", price: 597 },
];

const HomePage: React.FC = () => {
  return (
    <Layout>
      <FirstSlider />
      <CatalogLink />
      <div className={styles.buyersChoice}>
        <GeneralSlider title="Выбор покупателей" subtitle="Посмотреть все товары" slides={goodsArr} />
      </div>
      <NewGoods />
      <GeneralSlider title="Скидки" subtitle="Посмотреть все товары со скидками" slides={goodsArr} />
      <Ideas />
      <Feedback />
      <Company />
    </Layout>
  );
};

export default HomePage;
